// // YourOrders.js
// import React from 'react';
// import { useNavigate } from 'react-router-dom';
// import icons from "../../icons.config";
// import GlobalButton from "../GlobalButton";

// const YourOrders = ({ orders }) => {
//   const navigate = useNavigate();

//   return orders.length > 0 ? (
//     <div className="space-y-6 lg:pl-6">
//       {orders.map((order) => (
//         <div key={order.id} className="flex p-2 border-b pb-4">
//           {/* Left: Product Image */}
//           <img
//             src={order.items[0].image} // ✅ Access first product's image
//             alt={order.items[0].name} // ✅ Access first product's name
//             className="w-24 h-32 object-cover"
//           />

//           {/* Right: Order Details */}
//           <div className="ml-6 flex-1">
//             <h3 className="text-lg text-hcolor font-normal font-outfit">
//               Order ID: {order.id}
//             </h3>
//             <p className="text-primary1 font-outfit font-light text-2xl">
//               {order.items[0].name} {/* ✅ Access first product's name */}
//             </p>
//             <p className="text-hcolor text-lg font-poppins font-light">
//               Size: {order.items[0].selectedSize} {/* ✅ Use selectedSize */}
//             </p>
//             <p
//               className={`text-sm font-semibold relative top-6 ${
//                 order.status === "Delivered"
//                   ? "text-green-600"
//                   : order.status === "Shipped"
//                   ? "text-blue-600"
//                   : "text-yellow-600"
//               }`}
//             >
//               {order.status}
//             </p>
//           </div>

//           {/* Extreme Right: Price, Payment & Button */}
//           <div className="text-right">
//             <p className="text-xl font-medium">₹{order.items[0].discountedPrice}</p>
//             <p className="text-primary1 font-poppins font-normal text-base">
//               {order.paymentMethod} {/* ✅ Fix payment field */}
//             </p>
//             <button
//               onClick={() => navigate(`/order/${order.id}`)}
//               className="mt-3 px-4 py-2 bg-tertiary text-hcolor border-2 font-outfit font-medium"
//             >
//               ORDER DETAIL
//             </button>
//           </div>
//         </div>
//       ))}
//     </div>
//   ) : (
//     <div className="text-hcolor flex justify-center items-center text-center py-12">
//       <div className="relative top-8">
//         <img
//           src={icons.emptyOrder}
//           alt="No Orders"
//           className="relative left-[15%]"
//         />
//         <p>You haven't ordered anything yet.</p>
//         <button className="border-2 py-2 px-5 flex hover:text-hcolor font-outfit font-medium bg-hcolor text-primary2 hover:bg-tertiary transition-all duration-500 ease-in-out relative left-[25%] my-3">
//           <GlobalButton label="EXPLORE" routeName="shop" />
//         </button>
//       </div>
//     </div>
//   );
// };

// export default YourOrders;
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { fetchUserOrdersAPI } from "../../Providers/ordersProvider"; // API function
import icons from "../../icons.config";
import GlobalButton from "../GlobalButton";
import { FOUNDER_IMAGE_URL } from "../../api-urls";

const YourOrders = () => {
  const navigate = useNavigate();
  const [orders, setOrders] = useState([]);

  // Get authentication details
  const authToken = useSelector((state) => state.auth.authToken);
  const user_id =
    useSelector((state) => state.auth.user?.id) ||
    localStorage.getItem("user_id");

  useEffect(() => {
    console.log("Auth Token:", authToken);
    console.log("User ID:", user_id);

    if (!authToken || !user_id) {
      console.warn("Auth token or user ID missing, redirecting...");
      navigate("/login"); // Redirect if not authenticated
    } else {
      const fetchOrders = async () => {
        try {
          const response = await fetchUserOrdersAPI(authToken, user_id);
          console.log("API Response:", response);
          setOrders(response.data); // Ensure only data is set
        } catch (error) {
          console.error("Error fetching orders:", error);
        }
      };

      fetchOrders();
    }
  }, [authToken, user_id, navigate]);

  return orders.length > 0 ? (
    <div className="space-y-6 lg:pl-6">
      {orders.map((order) => (
        <>
          <div
            key={order._id}
            className="p-4 border rounded-lg shadow-md flex flex-col md:flex-row justify-between"
          >
            {/* image + order details div */}
            <div className="flex flex-1 flex-col md:flex-row gap-4">
              {/* image div */}
              <div className="w-full h-[50%] md:w-28 md:h-40 ">
                <img
                  src={FOUNDER_IMAGE_URL + order.products[0].variant_main_image}
                  alt="Product"
                  className="w-full h-full object-cover"
                />
              </div>

              {/* Order Details */}
              <div className=" ">
                {/* Product Details */}

                <h3 className="text-lg font-semibold text-gray-700">
                  Order ID: {order.id}
                </h3>
                <p className="text-sm font-semibold">
                  {order.products[0]?.sku}
                </p>
                <p className="text-gray-600">
                  Quantity: {order.products[0]?.quantity}
                </p>
                <p className="text-gray-600">Price: ₹{order.total_amount}</p>
                <p className="text-gray-600">Size: {order.products[0]?.size}</p>
                <span
                  className={`text-sm font-bold ${
                    order.order_status === "Delivered"
                      ? "text-green-600"
                      : order.order_status === "Shipped"
                      ? "text-blue-600"
                      : "text-yellow-600"
                  }`}
                >
                  {order.order_status}
                </span>
              </div>
            </div>
            {/* Pricing & Payment */}
            <div className=" flex flex-col gap-6 md:gap-14 justify-evenly h-full">
              {/* Total & Payment Info at the Top */}
              <div>
                <p className="text-lg font-semibold">
                  Total: ₹{order.total_amount}
                </p>
                <p className="text-gray-600 text-sm">
                  Payment: {order.payment_type}
                </p>
              </div>

              {/* Order Detail Button at the Bottom */}
              <div className="mt-auto">
                <button
                  onClick={() => navigate(`/order/${order.id}`)}
                  className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 border-2 border-hcolor flex items-center"
                >
                  ORDER DETAIL
                </button>
              </div>
            </div>
          </div>
        </>
      ))}
    </div>
  ) : (
    <div className="text-gray-600 flex justify-center items-center text-center py-12">
      <div>
        <img src={icons.emptyOrder} alt="No Orders" className="mx-auto" />
        <p className="mt-4">You haven't ordered anything yet.</p>
        <GlobalButton
          label="EXPLORE"
          routeName="shop"
          className="mt-4 px-4 py-2 bg-gray-700 text-white rounded hover:bg-gray-800"
        />
      </div>
    </div>
  );
};

export default YourOrders;
